import { FETCH_ALERTS, FETCH_ACTIVE_ALERTS } from '../actions/alert';

const initialState = {
  list: [],
  activeList: [],
  activeByDeviceId: {},

  activeFilteredList: [],
  activeFilteredByDeviceId: {}
};

/*
  The API contract is {data: [...]} — but the app must not white-screen when a response strays from
  it (a gateway error body, a truncated reply: the active-alerts query can run for tens of seconds
  and is re-polled every 30). The alert selectors call .reduce/.filter on these lists with no guard,
  so storing a non-array here crashed every mounted map. A malformed body keeps the previous list:
  it repaints on the next poll anyway, and one cycle of staleness beats an unmounted page.
*/
const asList = (payload, previous) => (Array.isArray(payload?.data) ? payload.data : previous);

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ACTIVE_ALERTS}_FULFILLED`:
      // ToDo: Check deep equality between state.activeList & action.payload.data
      return {
        ...state,
        activeList: asList(action.payload, state.activeList)
      };

    case `${FETCH_ALERTS}_FULFILLED`:
      return {
        ...state,
        list: asList(action.payload, state.list)
      };

    default:
      return state;
  }
};

export default alertReducer;
